import React, { useId } from 'react';
import { HONEYPOT_FIELD } from '../hooks/useFormProtection';

/**
 * A decoy input that is invisible to people but visible to form-filling bots.
 * Any value submitted here is rejected server-side.
 *
 * Positioned off-screen rather than `display: none` — some bots skip fields
 * that are display-hidden. Removed from the tab order and from the
 * accessibility tree so it never reaches a keyboard or screen-reader user.
 */
const HoneypotField = ({ value, onChange }) => {
    const id = useId();

    return (
        <div
            aria-hidden="true"
            style={{
                position: 'absolute',
                left: '-9999px',
                top: 'auto',
                width: '1px',
                height: '1px',
                overflow: 'hidden'
            }}
        >
            <label htmlFor={id}>Company website (leave this field empty)</label>
            <input
                type="text"
                id={id}
                name={HONEYPOT_FIELD}
                value={value}
                onChange={onChange}
                tabIndex={-1}
                autoComplete="off"
            />
        </div>
    );
};

export default HoneypotField;
